import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import Editor from './editor/editor.js';
import UserManager from './user-management/userManager.jsx';
import { ContextProvider } from './contextProvider.js';
import { TranscriptionsWebSocketProvider } from './transcriptionWssProvider.js';
import { ChatbotWebSocketProvider } from './chatbotWssProvider.js';
import Login from './pages/Login';
import keycloak from './keycloak';
import FilesBrowser from './file-browser/FilesBrowser.jsx';
import RecentFiles from './file-browser/recentFiles.jsx';
import { Navigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { ChatbotRuntimeProvider } from './chatbotRuntimeProvider.tsx';
import { Instructions } from './components/instructions.js';
import { TermsPrivacy } from './pages/termsAndPrivacy.js';


function App() {
  const initialized = useKeycloak();

  return (
    <ContextProvider>
      <ChatbotWebSocketProvider>
        <ChatbotRuntimeProvider>
          <SnackbarProvider
            preventDuplicate
            variant="success"
            dense
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
          >
            <Routes>
              <Route
                path="/privacy_terms"
                element={<TermsPrivacy />}
              />
              <Route
                path="/instructions"
                element={
                  <Instructions />
                }
              />
              {initialized.initialized && initialized.keycloak.authenticated ?
                <>
                  <Route path={'/*'} element={!keycloak.authenticated ? <Login /> : <Navigate to='/home' />} />
                  {/* <Route path={'/home/*'} element={<Homepage />} /> */}
                  <Route path={'/groupManagement'} element={<UserManager />} />
                  <Route
                    path={"/myFiles/*"}
                    element={
                      <TranscriptionsWebSocketProvider>
                        <FilesBrowser />
                      </TranscriptionsWebSocketProvider>
                    }
                  />
                  <Route
                    path={"/home"}
                    element={
                      <TranscriptionsWebSocketProvider>
                        <RecentFiles />
                      </TranscriptionsWebSocketProvider>
                    }
                  />
                  <Route
                    path="/editor"
                    element={(
                      <TranscriptionsWebSocketProvider>
                        <div className="w-full h-full overflow-auto">
                          <div id="modal" />
                          <Editor />
                        </div>
                      </TranscriptionsWebSocketProvider>
                    )}
                  />
                  <Route
                    path="/silent-check-sso"
                    element={
                      <html>
                        <body>
                          <script>
                            {parent.postMessage(location.href, location.origin)}
                          </script>
                        </body>
                      </html>
                    } />
                </> :
                <Route path="*" element={<Login />} />
              }
            </Routes>
          </SnackbarProvider>
        </ChatbotRuntimeProvider>
      </ChatbotWebSocketProvider>
    </ContextProvider>
  );
}

export default App;
